<template>
  <header class="top-header">
    <div class="header-inner">
      <hamburger-button v-if="isUserLoggedIn" class="hamburger-menu" @click="openMenu"/>
      <a :href="homePage" class="header-logo">
        <img class="logo desktop" src="/assets/images/logo-mtel-friends.png" width="143" height="39" alt="Moj m:tel"/>
        <img class="logo mobile" src="/assets/images/logo_mob.svg" width="60" height="39" alt="Moj m:tel"/>
      </a>
      <div class="user-dropdowns" v-if="isUserLoggedIn">
        <top-navigation-menu :nav-items="menuItems" :visible="menuVisible" @close-menu="closeMenu"/>
        <benefits-nav-link />
        <user-notifications/>
        <user-menu/>
      </div>
    </div>
  </header>
</template>

<script>
import UserMenu from '@/components/common/navigation/user-menu'
import { state } from '@/services/user'
import UserNotifications from '@/components/common/navigation/user-notifications'
import TopNavigationMenu from '@/components/common/navigation/top-navigation-menu'
import HamburgerButton from '@/components/common/navigation/hamburger-button'
import { customRouter } from '@/customRouter'
import BenefitsNavLink from '@/components/common/navigation/benefits-nav-link'

export default {
  name: 'top-header',
  data () {
    return {
      menuVisible: false
    }
  },
  components: { BenefitsNavLink, HamburgerButton, TopNavigationMenu, UserNotifications, UserMenu },
  props: {
    mainMenu: {
      type: String,
      default: '[]'
    }
  },
  computed: {
    isUserLoggedIn () {
      return state.isUserAuthorized
    },
    menuItems () {
      const mainMenuFromProps = JSON.parse(this.$props.mainMenu)
      return mainMenuFromProps.filter(item => item.Properties.topNavigation)
    },
    homePage () {
      return state.isUserAuthorized ? customRouter.getRouteByName({ name: 'servicesOverview' }) : customRouter.getRouteByName({ name: 'login' })
    }
  },
  methods: {
    openMenu () {
      this.menuVisible = true
    },
    closeMenu () {
      this.menuVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.top-header {
  background-color: #ffffff;
  height: 54px;
  width: 100%;

  @media (map_get($breakpoints, sm)) {
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
    height: 60px;
  }

  @media (map_get($breakpoints, lg)) {
    height: 68px;
  }

  @media (map_get($breakpoints, xxl)) {
    height: 88px;
  }

  .header-inner {
    width: 100%;
    height: 100%;
    padding: 0 2rem;
    margin: auto;
    display: flex;
    justify-content: flex-start;

    @media (map_get($breakpoints, md)) {
      max-width: 960px;
      padding: 0;
    }

    @media (map_get($breakpoints, lg)) {
      max-width: 1240px;
      padding: 0;
    }

    @media (map_get($breakpoints, xxl)) {
      max-width: 1600px;
      padding: 0;
    }

    .header-logo {
      display: flex;
      align-items: center;

      .logo {
        width: 143px;
        height: auto;
        margin: auto;

        &.desktop {
          display: none;

          @media (map_get($breakpoints, sm)) {
            display: inline-block;
          }
        }

        &.mobile {
          display: inline-block;
          width: 60px;
          height: auto;

          @media (map_get($breakpoints, sm)) {
            display: none;
          }
        }
      }
    }
  }

  .user-dropdowns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;
  }

  .hamburger-menu {
    display: block;

    @media (map_get($breakpoints, md)) {
      display: none;
    }
  }
}
</style>
